import { useContentEditingSafe } from "./ContentEditingContext";
import { PageSkeleton } from "./SkeletonLoading";

/**
 * PageSkeletonOverlay — shows a skeleton loading screen as an overlay
 * while content is being fetched from Supabase.
 * Fades out once loading is complete.
 */
export function PageSkeletonOverlay() {
  const ctx = useContentEditingSafe();
  const isLoading = ctx?.isLoading ?? false;

  if (!isLoading) return null;

  return (
    <div
      className="fixed inset-0 z-[900] bg-white"
    >
      <PageSkeleton />
    </div>
  );
}
